import React,{useState} from 'react';
import ReactHtmlParser from "react-html-parser";
import SkeletonContainer, { getSkeletonHeight } from '../../loaders/SekletonContainer';
import { Heading3, Heading5 } from '../common/GlobalElements/Typography';
import { ContainerWrapper } from '../common/GlobalElements/Wrappers';
import { tokens } from '../../public/tokens';

export default function ExamRightBoxInformation(props){

    const [loading,setLoading]=useState(true);

    setTimeout(()=>{
        setLoading(false);
    },1000)
    const {content} = props;

    return(<>
        {loading && <SkeletonContainer height={getSkeletonHeight(25)} />}
        {!loading && (
            <div className="exam-detail-rgt">
            <div className="exam-detail-top d-flex justify-content-between">
                    <div className="exam-detail-top-left">
                        <div className="exam-bx-info  d-flex">
                                <div className="icon">
                                        ME
                                </div>
                                <div className="exam-bx-info-rgt">
                                        <Heading3>External Exam Registration Form</Heading3>
                                        <p>Register here for your DoE National Exams. Please ensure that you have completed all the required fields</p>
                                </div>
                        </div>
                    </div>
            </div>

            <div className="exam-register-bx">
            <div className="card card-form-bx">
				<Heading5 marginBottom={tokens.globals["spacing-sm"]}>Application Comments</Heading5>

                <ContainerWrapper>
					<div className="theme-form application-form">
						<div className="row">
                            <div className="col-12">
                            {content !== ''?ReactHtmlParser(content):''}      
                            </div>                     
                        </div>
                    </div>
                </ContainerWrapper>

            </div>
            </div>

        </div>
        )}
    </>);
}